export default "__VITE_ASSET__DzknwBFv__"